/**
 * @file consent-texts-format.ts
 * @description Подписи экрана «Согласие на cookie» (phase19.16, Р3г;
 * uiux-r3g-consent-texts §2): дата и время редакции, строка истории
 * «Ред. N · дата · автор», строка черновика «Черновик · Анна · 5 мин назад»,
 * охват «Получили N из M магазинов со счётчиками».
 */

import type { ConsentTextShopsReach } from "../api-consent-texts";
import { timeAgo } from "../site-builder/page-status";

/** `2026-10-23T09:05:00Z` → `23.10.2026 14:05` (время браузера). */
export function formatConsentDateTime(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "—";
  const day = date.toLocaleDateString("ru-RU", { day: "2-digit", month: "2-digit", year: "numeric" });
  const time = date.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" });
  return `${day} ${time}`;
}

/** Строка истории: «Ред. 2 · 23.10.2026 14:05 · Иван Петров». */
export function revisionLine(r: { number: number; publishedAt: string; publishedByName: string }): string {
  return [`Ред. ${r.number}`, formatConsentDateTime(r.publishedAt), r.publishedByName].filter(Boolean).join(" · ");
}

/** «Черновик · Анна · 5 мин назад». */
export function draftLine(authorName: string, savedAt: string, now: Date = new Date()): string {
  return ["Черновик", authorName, timeAgo(savedAt, now)].filter(Boolean).join(" · ");
}

/** «Получили 3 из 5 магазинов со счётчиками»; нет данных — null. */
export function reachLine(shops: ConsentTextShopsReach | undefined): string | null {
  if (!shops) return null;
  return `Получили ${shops.onCurrent} из ${shops.withCounters} магазинов со счётчиками`;
}

/** «1 поле», «2 поля», «5 полей». */
export function fieldsWord(n: number): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return `${n} поле`;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return `${n} поля`;
  return `${n} полей`;
}
